import { render, staticRenderFns } from "./avatar-friends.vue?vue&type=template&id=c13995b0&"
import script from "./avatar-friends.vue?vue&type=script&lang=js&"
export * from "./avatar-friends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports